import { atom } from 'recoil';

export const gameUiVisibleState = atom<boolean>({
  key: 'gameUiVisibleState',
  default: true,
});